// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__141we","col":"CardReaderDesc_col__10wOZ","label":"CardReaderDesc_label__3utwT"};